<template>
  <div v-if="event.show_series.length">
    <p class="text-2xl mb-6 font-medium">This event is part of the following series:</p>

    <div  class="border-b pb-4 mb-2 md:mb-4 flex flex-wrap justify-between">
      <div v-for="(s,si) in event.show_series" :key="si" class="w-full md:w-1/3 pr-2 mb-5 md:mb-1">
        <a class="text-lg mb-1 font-medium link" :href="`/shows#/show-series/${s.series_identifier}`">{{s.name}}</a>
        <template v-if="s.online_membership">
          <template v-if="seriesMembership.filter(sm => sm.show_series_id === s.show_series_id).length">
            <div class="mb-1">
              <p>Registered Members:</p>
              <p v-for="(m, mi) in seriesMembership.filter(sm => sm.show_series_id === s.show_series_id)" :key="mi" class="text-sm font-bold">
                {{m.exhibitor.first_name}} {{m.exhibitor.last_name}} ~ <span v-if="m.membership_status !== 'ACTIVE'">PENDING PAYMENT</span> <span v-else>{{m.membership_number}} </span>
              </p>
            </div>
          </template>
          <template v-else>
            <p>There are no exhibitors on this account registered as members</p>
          </template>
          <a class="link text-sm" :href="`/shows#/show-series/${s.series_identifier}/join`">
            Register a new exhibitor
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    event () {
      return this.$store.state.event.currentEvent
    },
    seriesMembership () {
      let members = []
      this.$store.state.userData.show_series_membership.forEach(m => {
        if (this.event.show_series.find(s => s.show_series_id === m.show_series_id)) {
          let exhibitor = this.$store.state.userData.exhibitors.find(e => e.exhibitor_id === m.exhibitor_id)
          m.exhibitor = {
            first_name: exhibitor.first_name,
            last_name: exhibitor.last_name
          }
          members.push(m)
        }
      })
      return members
    }
  }
}
</script>

<style>

</style>
